import React from 'react';
export function Datenschutz() {
  return <div className="pt-32 pb-24 max-w-3xl mx-auto px-6 md:px-12 min-h-screen" data-id="element-104">
      <h1 className="text-4xl md:text-5xl font-serif text-accent mb-12" data-id="element-105">
        Datenschutzerklärung
      </h1>

      <div className="space-y-10 text-accent/80 font-light leading-relaxed" data-id="element-106">
        <section data-id="element-107">
          <h2 className="text-2xl font-medium text-accent mb-4" data-id="element-108">
            1. Verantwortlicher
          </h2>
          <p className="mb-4" data-id="element-109">
            Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne
            der Datenschutz-Grundverordnung (DSGVO) ist:
          </p>
          <p className="mb-4" data-id="element-110">
            Josephine Henkel
            <br data-id="element-111" />
            Bastianstraße 10
            <br data-id="element-112" />
            13357 Berlin
            <br data-id="element-113" />
            Deutschland
          </p>
          <p data-id="element-114">
            Telefon: +49 173 5227433
            <br data-id="element-115" />
            E-Mail: info@henkelenergie.de
          </p>
        </section>

        <section data-id="element-116">
          <h2 className="text-2xl font-medium text-accent mb-4" data-id="element-117">
            2. Allgemeine Hinweise zum Datenschutz
          </h2>
          <p data-id="element-118">
            Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir
            behandeln Ihre personenbezogenen Daten vertraulich und entsprechend
            der gesetzlichen Datenschutzvorschriften sowie dieser
            Datenschutzerklärung. Wenn Sie diese Website benutzen, werden
            verschiedene personenbezogene Daten erhoben. Personenbezogene Daten
            sind Daten, mit denen Sie persönlich identifiziert werden können.
            Diese Datenschutzerklärung erläutert, welche Daten wir erheben und
            wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck
            das geschieht.
          </p>
        </section>

        <section data-id="element-119">
          <h2 className="text-2xl font-medium text-accent mb-4" data-id="element-120">
            3. Hosting und Server-Logfiles
          </h2>
          <p className="mb-4" data-id="element-121">
            Der Provider der Seiten erhebt und speichert automatisch
            Informationen in so genannten Server-Logfiles, die Ihr Browser
            automatisch an uns übermittelt. Dies sind:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-122">
            <li data-id="element-123">IP-Adresse</li>
            <li data-id="element-124">Datum und Uhrzeit der Serveranfrage</li>
            <li data-id="element-125">Aufgerufene Seite bzw. Name der abgerufenen Datei</li>
            <li data-id="element-126">Browsertyp und Browserversion</li>
            <li data-id="element-127">Verwendetes Betriebssystem</li>
            <li data-id="element-128">Referrer-URL (die zuvor besuchte Seite)</li>
          </ul>
          <p data-id="element-129">
            Eine Zusammenführung dieser Daten mit anderen Datenquellen wird
            nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage
            von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse
            an der technisch fehlerfreien Darstellung und der Optimierung
            unserer Website – hierzu müssen die Server-Logfiles erfasst werden.
          </p>
        </section>

        <section data-id="element-130">
          <h2 className="text-2xl font-medium text-accent mb-4" data-id="element-131">
            4. Kontaktformular / Mailformular
          </h2>
          <p className="mb-4" data-id="element-132">
            Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen
            lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der
            von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der
            Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
            Dies umfasst insbesondere:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-133">
            <li data-id="element-134">Name (sofern angegeben)</li>
            <li data-id="element-135">E-Mail-Adresse</li>
            <li data-id="element-136">Inhalt der Nachricht</li>
            <li data-id="element-137">
              Weitere von Ihnen freiwillig gemachte Angaben (z. B.
              Telefonnummer, Objektstandort)
            </li>
          </ul>
          <p className="mb-4" data-id="element-138">
            Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs.
            1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags
            zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
            erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung
            auf unserem berechtigten Interesse an der effektiven Bearbeitung der
            an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO).
          </p>
          <p data-id="element-139">
            Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei
            uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur
            Speicherung widerrufen oder der Zweck für die Datenspeicherung
            entfällt (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage).
            Zwingende gesetzliche Bestimmungen – insbesondere
            Aufbewahrungsfristen – bleiben unberührt.
          </p>
        </section>

        <section data-id="element-140">
          <h2 className="text-2xl font-medium text-accent mb-4" data-id="element-141">
            5. SSL-/TLS-Verschlüsselung
          </h2>
          <p data-id="element-142">
            Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
            Übertragung vertraulicher Inhalte, wie zum Beispiel Anfragen, die
            Sie an uns als Seitenbetreiber senden, eine SSL- bzw.
            TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie
            daran, dass die Adresszeile des Browsers von „http://“ auf
            „https://“ wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
            Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die
            Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen
            werden.
          </p>
        </section>

        <section data-id="element-143">
          <h2 className="text-2xl font-medium text-accent mb-4" data-id="element-144">
            6. Technisch notwendige Cookies
          </h2>
          <p className="mb-4" data-id="element-145">
            Unsere Website verwendet gegebenenfalls technisch notwendige
            Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät
            gespeichert werden. Sie richten keinen Schaden an und enthalten
            keine Viren. Technisch notwendige Cookies sind erforderlich, um die
            grundlegenden Funktionen der Website sicherzustellen.
          </p>
          <p className="mb-4" data-id="element-146">
            Die Speicherung von technisch notwendigen Cookies erfolgt auf
            Grundlage von § 25 Abs. 2 TDDDG sowie Art. 6 Abs. 1 lit. f DSGVO.
            Wir haben ein berechtigtes Interesse an der Speicherung von Cookies
            zur technisch fehlerfreien und reibungslosen Bereitstellung unserer
            Dienste.
          </p>
          <p data-id="element-147">
            <strong data-id="element-148">Klarstellung:</strong> Auf dieser Website findet kein
            Tracking statt. Es werden keine Analyse-Tools (wie Google
            Analytics), keine externen Schriftarten (wie Google Fonts), keine
            Social-Media-Plugins und keine Marketing-Cookies verwendet. Das
            Nutzerverhalten wird nicht analysiert.
          </p>
        </section>

        <section data-id="element-149">
          <h2 className="text-2xl font-medium text-accent mb-4" data-id="element-150">
            7. Ihre Betroffenenrechte
          </h2>
          <p className="mb-4" data-id="element-151">
            Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen
            jederzeit das Recht auf unentgeltliche Auskunft über Ihre
            gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger
            und den Zweck der Datenverarbeitung (Art. 15 DSGVO) und ggf. ein
            Recht auf Berichtigung (Art. 16 DSGVO), Sperrung oder Löschung
            dieser Daten (Art. 17 DSGVO).
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-152">
            <li data-id="element-153">
              <strong data-id="element-154">
                Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO):
              </strong>{' '}
              Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer
              personenbezogenen Daten zu verlangen.
            </li>
            <li data-id="element-155">
              <strong data-id="element-156">Recht auf Datenübertragbarkeit (Art. 20 DSGVO):</strong>{' '}
              Sie haben das Recht, Daten, die wir auf Grundlage Ihrer
              Einwilligung oder in Erfüllung eines Vertrags automatisiert
              verarbeiten, an sich oder an einen Dritten in einem gängigen,
              maschinenlesbaren Format aushändigen zu lassen.
            </li>
            <li data-id="element-157">
              <strong data-id="element-158">
                Beschwerderecht bei der zuständigen Aufsichtsbehörde (Art. 77
                DSGVO):
              </strong>{' '}
              Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein
              Beschwerderecht bei einer Aufsichtsbehörde zu.
            </li>
          </ul>
        </section>

        <section data-id="element-159">
          <h2 className="text-2xl font-medium text-accent mb-4" data-id="element-160">
            8. Widerspruchsrecht (Art. 21 DSGVO)
          </h2>
          <p data-id="element-161">
            <strong data-id="element-162">
              Wenn die Datenverarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f
              DSGVO (berechtigtes Interesse) erfolgt, haben Sie jederzeit das
              Recht, aus Gründen, die sich aus Ihrer besonderen Situation
              ergeben, gegen die Verarbeitung Ihrer personenbezogenen Daten
              Widerspruch einzulegen. Wenn Sie Widerspruch einlegen, werden wir
              Ihre betroffenen personenbezogenen Daten nicht mehr verarbeiten,
              es sei denn, wir können zwingende schutzwürdige Gründe für die
              Verarbeitung nachweisen, die Ihre Interessen, Rechte und
              Freiheiten überwiegen, oder die Verarbeitung dient der
              Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
            </strong>
          </p>
        </section>

        <section data-id="element-163">
          <h2 className="text-2xl font-medium text-accent mb-4" data-id="element-164">
            9. Änderungen der Datenschutzerklärung
          </h2>
          <p data-id="element-165">
            Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit
            sie stets den aktuellen rechtlichen Anforderungen entspricht oder um
            Änderungen unserer Leistungen in der Datenschutzerklärung
            umzusetzen. Für Ihren erneuten Besuch gilt dann die neue
            Datenschutzerklärung.
          </p>
        </section>
      </div>
    </div>;
}